import React, { useEffect, useState } from 'react';
import css from './MobileMenu.module.scss';
import DropdownProduct from '@components/Header/DropdownProduct';
import DropdownShowcase from '@components/Header/DropdownShowcase';
import DropdownResources from '@components/Header/DropdownResources';
import DropdownCompany from '@components/Header/DropdownCompany';
import constructURLWithQueryParams from '@utils/constructURLWithQueryParams';
import useLocalStorageValues from '@utils/useLocalStorageValues';
import { PrismicButton } from '@components/Button/Button';
import Link from '@components/Link/Link';
import { LinkButton } from '@components/Button/Button';
import { TNS } from '../../config';

import SymbolSharetribe from '@images/logos/SymbolSharetribe/SymbolSharetribe';

const MenuProducts = () => {
  const [isOpen, setIsOpen] = useState(false);
  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={css.menuItem}>
      <div className={css.linkContainer}>
        <div
          className={css.parentLink}
          onClick={handleClick}
          onKeyUp={handleClick}
          role="button"
          tabIndex="0"
        >
          <span>Product</span>
          <p className={css.showSubmenu}>{isOpen ? '–' : '+'}</p>
        </div>
      </div>
      <div className={isOpen ? css.subLinksVisible : css.subLinksHidden}>
        <DropdownProduct />
      </div>
    </div>
  );
};

const MenuPricing = () => {
  const [isOpen, setIsOpen] = useState(false);
  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={css.menuItem}>
      <div className={css.linkContainer}>
        <Link to="/pricing/" className={css.parentLink}>
          Pricing
        </Link>
      </div>
    </div>
  );
};

const MenuCustomerStories = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={css.menuItem}>
      <div className={css.linkContainer}>
        <div
          className={css.parentLink}
          onClick={handleClick}
          onKeyUp={handleClick}
          role="button"
          tabIndex="0"
        >
          <span>Showcase</span>
          <p className={css.showSubmenu}>{isOpen ? '–' : '+'}</p>
        </div>
      </div>
      <div className={isOpen ? css.subLinksVisible : css.subLinksHidden}>
        <DropdownShowcase />
      </div>
    </div>
  );
};

const MenuResources = () => {
  const [isOpen, setIsOpen] = useState(false);
  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={css.menuItem}>
      <div className={css.linkContainer}>
        <div
          className={css.parentLink}
          onClick={handleClick}
          onKeyUp={handleClick}
          role="button"
          tabIndex="0"
        >
          <span>Resources & Support</span>
          <p className={css.showSubmenu}>{isOpen ? '–' : '+'}</p>
        </div>
      </div>
      <div className={isOpen ? css.subLinksVisible : css.subLinksHidden}>
        <DropdownResources />
      </div>
    </div>
  );
};

const MenuCompany = () => {
  const [isOpen, setIsOpen] = useState(false);
  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={css.menuItem}>
      <div className={css.linkContainer}>
        <div
          className={css.parentLink}
          onClick={handleClick}
          onKeyUp={handleClick}
          role="button"
          tabIndex="0"
        >
          <span>Company</span>
          <p className={css.showSubmenu}>{isOpen ? '–' : '+'}</p>
        </div>
      </div>
      <div className={isOpen ? css.subLinksVisible : css.subLinksHidden}>
        <DropdownCompany />
      </div>
    </div>
  );
};

const MobileMenu = props => {
  const [tnsURL, setTnsURL] = useState(TNS.START_BUILDING_URL);
  const { rfsn, referrer, firstPageVisited } = useLocalStorageValues();

  useEffect(() => {
    setTnsURL(
      constructURLWithQueryParams(TNS.START_BUILDING_URL, rfsn, referrer, firstPageVisited)
    );
  }, [rfsn, referrer, firstPageVisited]);
  return (
    <div className={css.container}>
      <div className={css.sharetribeLogos}>
        <SymbolSharetribe />
      </div>
      <div className={css.menuWrapper}>
        <MenuProducts />
        <MenuPricing />
        <MenuCustomerStories />
        <MenuResources />
        <MenuCompany />
      </div>
      <div className={css.bottom}>
        <div className={css.buttonWrapper}>
          <div className={css.ctaLogin}>
            <LinkButton to={TNS.LOGIN_URL}>Log in</LinkButton>
          </div>
          <div className={css.cta}>
            <PrismicButton
              to={tnsURL}
              analyticsEvent="custom-sharetribe-account-started"
              analyticsProperties={{ position: 'header--main' }}
            >
              Start free trial
            </PrismicButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
